module.exports = __webpack_public_path__ + "img/nav-thumbnail-boomerang2d.d2c6a11c.png";